const en = {
  jumbotronTitle: 'WHY CHOOSE SBOTOP',
  jumbotronDescription: 'As one of the world’s leading online gaming brands, SBOTOP prides itself to foster TRUST, VALUE, and SPEED to its esteemed clientele.',
  jumbotronBtn: 'Play on SBOTOP Now',
  articleTitle: 'Trusty Brand, Magnificent Prices, Agile Payout',
  articleText1: 'SBOTOP offers the highest-rated odds among the global primary sportsbooks while taking care of payment effectively. Each payment-relevant request is dealt with within 3 hours of receipt.Diverse payment methods for customers to deposit and withdraw are provided, too. Settlement on SBOTOP has never been smoother!',
  articleText2: 'SBOTOP Sports has over 1000 sporting events every week. The coverage includes football, basketball, cricket and even eSports. There are a lot of choices, and SBOTOP is guaranteed to cover whatever sport you like.',
  sectionText1: 'The SBOTOP’s Loyalty Program, making the globe your reward shop.',
  sectionTitle2: 'News',
  sectionText2: 'IGL Season II Begins, Sponsors Prepare Hundreds of Million Prizes.',
};

const id = {
  jumbotronTitle: 'Mengapa Memilih SBOTOP',
  jumbotronDescription: 'Sebagai salah satu brand permainan online terkemuka di dunia, SBOTOP berkomitmen penuh untuk memberikan pelayanan dengan selalu mengutamakan KEPERCAYAAN, KUALITAS, dan KECEPATAN untuk member-member istimewa kami.',
  jumbotronBtn: 'Main di SBOTOP Sekarang',
  articleTitle: 'Brand Terpercaya, Penawaran Odds Tinggi, Pencairan Instan',
  articleText1: 'SBOTOP menawarkan nilai odds / pasaran tertinggi di antara sejumlah sportsbook besar di dunia dan tetap memprioritaskan sistem pencairan taruhan yang efektif. Permintaan terkait dengan pembayaran siap diproses kurang dari 3 jam. Pilihan pembayaran yang beragam juga disediakan bagi member untuk kemudahan transaksi deposit dan penarikan. Nikmati juga proses pencairan taruhan yang cepat di SBOTOP!',
  articleText2: 'Halaman Olahraga SBOTOP menawarkan pilihan terlengkap hingga lebih dari 1000 pertandingan setiap minggunya, mulai dari sepak bola, bola basket, kriket dan bahkan eSports, apapun olahraga favorit Anda, dijamin akan Anda temukan di SBOTOP!',
  sectionText1: 'Program Loyalitas SBOTOP, akses Anda menuju dunia penuh dengan penawaran dan hadiah menarik.',
  sectionTitle2: 'Berita',
  sectionText2: 'IGL Season II Dimulai, Sponsor Siapkan Hadiah Ratusan Juta.',
};

$(function() {
  const $elements = {
    body: $('body'),
    navbar: $(".navbar"),
    navbarLogo: $(".logo-sbotop"),
    langENBtn: $('.js_lang_en'),
    langIDBtn: $('.js_lang_id')
  };

  i18next.use(i18nextBrowserLanguageDetector)
    .init({
      fallbackLng: 'en',
      debug: false,
      lng: i18next.language,
      resources: {
        en: {
          translation: en
        },
        id: {
          translation: id
        }
      }
    }, function (err, t) {
      // attach navigator language
      translateUIRender(i18next.language);
      // init set content
      updateContent();
    });

  function updateContent() {
    // add lang class on body to adjust layout
    $elements.body.removeClass('_langEN _langID');
    $elements.body.addClass(`_lang${i18next.language.toUpperCase()}`);

    // change language
    $('[data-i18n]').each((i, el) => {
      $(el).html(i18next.t($(el).data('i18n')));
    })
  }

  function changeLng(lng) {
    i18next.changeLanguage(lng);
  }

  function translateUIRender(lang) {
    if (lang === 'id') {
      $elements.langENBtn.removeClass('_active');
      $elements.langIDBtn.addClass('_active');
      changeLng('id');
    } else {
      $elements.langIDBtn.removeClass('_active');
      $elements.langENBtn.addClass('_active');
      changeLng('en');
    }
  }

  i18next.on('languageChanged', () => {
    updateContent();
  });

  $elements.langENBtn.on('click', function (e) {
    e.preventDefault();
    translateUIRender('en');
  });

  $elements.langIDBtn.on('click', function (e) {
    e.preventDefault();
    translateUIRender('id');
  });

  // listen scroll event to toggle navbar show/hide background color
  $(window).on(
    "scroll",
    debounce(function() {
      if ($(this).scrollTop() > 10) {
        $elements.navbar.addClass("_hasBgColor");
      } else {
        $elements.navbar.removeClass("_hasBgColor");
      }
    }, 0)
  );

  $elements.navbarLogo.on("click", function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 500);
  });
});

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
